import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import {
  getSelectedProgramPlan,
  promotion_discount,
  coupon_discount,
  MINIMUM_CHARGE
} from "./utils";

const TransactionCostProgramDropIn = props => {
  const [fee, setFee] = useState("Loading");

  const calculateFeeAmount = () => {
    const plan = getSelectedProgramPlan(props.program, props.selected);
    const total_price = parseFloat(plan.total_price);
    const dayCount = parseInt(plan.dayCount);
    const dropin_interest = parseInt(plan.dropin_interest);

    const subtotal =
      (total_price / dayCount) *
      (1 + dropin_interest / 100) *
      props.selected_days_length;

    if (props.promotion) {
      const tax_percent = parseFloat(1.5) / 100;
      const discount_amount = promotion_discount(props.promotion, subtotal);
      const calcFee =
        Math.max(MINIMUM_CHARGE, subtotal - discount_amount) * tax_percent;

      props.creditCardFeeAmount(calcFee.toFixed(2));
      setFee(calcFee.toFixed(2));
    } else {
      const tax_percent = parseFloat(1.5) / 100;
      const discount_amnout = props.coupon
        ? coupon_discount(props.coupon, subtotal)
        : 0;
      const calcFee =
        Math.max(MINIMUM_CHARGE, subtotal - discount_amnout) * tax_percent;

      props.creditCardFeeAmount(calcFee.toFixed(2));

      setFee(calcFee.toFixed(2));
    }
  };

  useEffect(() => {
    calculateFeeAmount();
  }, []);

  return (
    <li
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "15px 10px",
        borderBottom: "1px solid #dedede"
      }}
    >
      <p
        style={{
          marginBottom: 0,
          fontFamily: "Open Sans, sans-serif",
          fontWeight: 500,
          fontSize: "14px"
        }}
      >
        Credit Card Fee (1.5%)
      </p>
      <span style={{ fontWeight: 500, fontSize: "14px" }}>${fee}</span>
    </li>
  );
};

TransactionCostProgramDropIn.propTypes = {
  program: PropTypes.shape({
    plans: PropTypes.array.isRequired
  }).isRequired,
  selected: PropTypes.number.isRequired,
  promotion: PropTypes.object,
  coupon: PropTypes.object
};

export default TransactionCostProgramDropIn;
